import {sendRequest} from '../axios'

export default {
    state: {
        menu: [],
        url: '/mywins',
        filter: false,
    },
    mutations: {
        SET_URL(state,payload) {
            state.url = payload;
        },
        SET_MENU(state,payload) {
            state.menu = payload
        },
        CLEAR_MENU(state) {
            state.menu = [];
        },
        setFilter(state,payload){
          state.filter = payload
        }
    },
    actions: {
        setFilter({commit},val){
          commit('setFilter',val)
        },
        clearMenu({commit}) {
            commit('CLEAR_MENU');
            localStorage.removeItem('menu');
            localStorage.removeItem('url');
        },
    },
    getters: {
        getMenuItems: (state) => state.menu,
        getMenuUrl: (state) => state.url,
        filter: (state)=>state.filter
    }
}
